/* eslint-disable array-callback-return */
import React, { useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import "./ToggleButton.css";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function ViewStaff(state) {
  const { id } = useParams();
  const [userfirstname, setuserfirstname] = useState("");
  const [userlastname, setuserlastname] = useState("");
  const [userFatherName, setuserFatherName] = useState("");
  const [userMotherName, setuserMotherName] = useState("");
  const [usermobilenumber, setmobilenumber] = useState("");
  const [useridnumber, setidnumber] = useState("");
  const [usercity, setcity] = useState("");
  const [cityid, setcityid] = useState("");
  const [zoneid, setzoneid] = useState("");
  const [userzone, setzone] = useState("");
  const [img, setImg] = useState("");
  const [img1, setImg1] = useState("");
  const [img2, setImg2] = useState("");
  // const [images, setimages] = useState(`http://192.168.1.109/liretna_back/public/images/${id}/personal_photo.png`);
  const [Succes, setSucces] = useState(false);

  const [Permission, setPermission] = useState([]);
  const [d, setd] = useState([]);
  const [satffFund, setSatffFund] = useState([]);
  const [type, setStaffType] = useState([]);
  const [company, setStaffCompany] = useState([]);
  const [fundvalue, setStafffundvalue] = useState([]);
  const [Permission1, setPermission1] = useState([]);
  const [Permission2, setPermission2] = useState([]);
  const [usercreated, setcreated] = useState("");
  const [on, setOnState] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  // },[images]);
  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/getStaffFunds/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setSatffFund(res.data.data.map((e) => e.fund_name));
        setStafffundvalue(res.data.data.map((e) => e.amount));
        setStaffCompany(res.data.data.map((e) => e.fund_company));
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/staff/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setSucces(true);
        setuserfirstname(res.data.first_name);
        setuserlastname(res.data.last_name);
        setuserFatherName(res.data.father_name);
        setuserMotherName(res.data.mother_name);
        setmobilenumber(res.data.mobile_number);
        setidnumber(res.data.id_number);
        setStaffType(res.data.staff_type);
        setcity(res.data.city_id.name_ar);
        setcityid(res.data.city_id.id);
        setzoneid(res.data.zone_id.id);
        setzone(res.data.zone_id.name);
        setcreated(res.data.login_information.created_at);
        setImg(res.data.images.personal_photo);
        setImg1([res.data.images.id_photo1]);
        setImg2([res.data.images.id_photo2]);
      })
      .catch((err) => {});
  }, []);
  
  // useEffect(() => {
  //   axios
  //     .get(
  //       `http://192.168.1.109/liretna_back/public/images/${id}/personal_photo.png`,
  //       {
  //         withCredentials: true,
  //       }
  //     )
  //     .then((res) => {
  //     })
  //     .catch((err) => {});
  // }, [id]);

  function handelUpdateImage(id) {
    navigate(`/update_personal_image/${id}`, { state: { id: id } });
  }
  const staff_type = localStorage.getItem("staff_type");
  const per = Permission2.map((e1, i) => e1["p"].id);
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const updateStaff = (id, cityid, zoneid) => () => {
    navigate(`/update-staff/${id}/${cityid}/${zoneid}`, {
      state: { id: id, cityid: cityid, zoneid: zoneid },
    });
  };
  const updatePasswordStaff = (id) => () => {
    navigate(`/reset-password-staff/${id}`, {
      state: { id: id, cityid: cityid, zoneid: zoneid },
    });
  };

  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/permission`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setPermission(res.data.data);

        setPermission(
          res.data.data.map((n) => ({
            ...id,
            ["p"]: { id: n.id, name: n.name, guard_name: n.guard_name },
          }))
        );
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/permission/getstaffPermission/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setPermission2(res.data.data);

        setPermission2(
          res.data.data.map((n) => ({
            ...id,
            ["p"]: { id: n.id, name: n.name },
          }))
        );

        setPermission1(res.data.data.map((e) => e.name));
      })
      .catch((err) => {});
  }, []);
  const ToggleButtonOff = ({ idpermission }) => {
    const [isOff, setIsOff] = useState(false);
    const onsave = () => {
      if (isOff === true) {
        const data = {
          staff_id: id,
          permission_id: idpermission,
        };

        axios
          .post(
            `${BaseUrl}/api/permission/addPermissionToStaff`,
            data,
            {
              withCredentials: true,
            }
          )
          .then((res) => {
            if (res.data.status === true) {
              sweetalert("تم  تحديث الصلاحية بنجاح بنجاح", {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                axios
                .get(
                  `${BaseUrl}/api/permission/getstaffPermission/${id}`,
                  {
                    withCredentials: true,
                  }
                )
                .then((res) => {
                  setPermission2(res.data.data);
          
                  setPermission2(
                    res.data.data.map((n) => ({
                      ...id,
                      ["p"]: { id: n.id, name: n.name },
                    }))
                  );
          
                  setPermission1(res.data.data.map((e) => e.name));
                })
                // window.location.reload();
              });
            }
          });
      }
    };
    return (
      <>
        <button
          onClick={() => setIsOff(!isOff)}
          className={isOff ? "on" : "off"}
        >
          {isOff ? "ON" : "OFF"}
        </button>
        {isOff ? (
          <button onClick={onsave} className="enable">
            تفعيل
          </button>
        ) : (
          <button disabled className="disabled">
          تفعيل
          </button>
        )}
      </>
    );
  };

  const ToggleButtonOn = ({ idpermission }) => {
    const [isOff, setIsOff] = useState(true);
    const ondelete = () => {
      if (isOff === true) {
        const data = {
          staff_id: id,
          permission_id: idpermission,
        };

        axios
          .post(
            `${BaseUrl}/api/DeletePermissionToStaff`,
            data,
            {
              withCredentials: true,
            }
          )
          .then((res) => {
            if (res.data.status === true) {
              sweetalert("تم حذف الصلاحية بنجاح ", {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                     axios
                .get(
                  `${BaseUrl}/api/permission/getstaffPermission/${id}`,
                  {
                    withCredentials: true,
                  }
                )
                .then((res) => {
                  setPermission2(res.data.data);
          
                  setPermission2(
                    res.data.data.map((n) => ({
                      ...id,
                      ["p"]: { id: n.id, name: n.name },
                    }))
                  );
          
                  setPermission1(res.data.data.map((e) => e.name));
                })
                // window.location.reload();
              });
            }
          });
      }
      if (isOff === false) {
      }
    };
    return (
      <>
        <button
          onClick={() => setIsOff(!isOff)}
          disabled={isOff ? true : false}
          className={isOff ? "on" : "off"}
        >
          {isOff ? "ON" : "OFF"}{" "}
        </button>
        {isOff ? (
          <button onClick={ondelete} className="delete">
            إلغاء تفعيل
          </button>
        ) : (
          <button disabled className="disabled">
            تفعيل
          </button>
        )}
      </>
    );
  };
  return (
    <div className="main-div">
      <Grid container spacing={2} className="user-info">
        <img className="user-img" src={img} alt="user-img"></img>
        <h3>
          {userfirstname} {userlastname}
        </h3>
      </Grid>
      <Grid container spacing={2}>
        {type == "ادمن" ? null : (
          <Grid item md={4} xs={12} className="">
            <div className="permission">
              <div className="userpermisionborder">
                <h3>الصلاحيات</h3>
              </div>
              <div>
                <div className="salam">
                  <div>
                    {Permission.map((e, i) => {
                      return (
                        <div key={i}>
                          <p style={{ padding: "10px" }}>
                            {e["p"].name}
                            {/* {e["p"].guard_name} */}
                          </p>{" "}
                          {per.includes(e["p"].id) ? (
                            <ToggleButtonOn idpermission={e["p"].id} />
                          ) : (
                            <ToggleButtonOff idpermission={e["p"].id} />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        )}

        <Grid item md={8} xs={12}>
          <div className="userdetails">
            <div className="userdetailsborder">
              <h3>البيانات الشخصية</h3>
              <div>
                {staff_type === "Admin" ? (
                  <button
                    className="btn-user-details"
                    onClick={updatePasswordStaff(id)}
                  >
                    تغيير كلمة المرور
                  </button>
                ) : (
                  <></>
                )}
                {Succes == true ? (
                  <button
                    className="btn-user-details"
                    onClick={updateStaff(id, cityid, zoneid)}
                  >
                    تعديل
                  </button>
                ) : (
                  <button
                  className="btn-user-details"
                   onClick={updateStaff(id, cityid, zoneid)}
                  >
                    تعديل
                  </button>
                )}

                <button className="btn-user-details" onClick={handleClickOpen}>
                  عرض الصور
                </button>
                <Dialog open={open} onClose={handleClose}>
                  <DialogTitle>صور المستخدم</DialogTitle>

                  <DialogContent>
                    <DialogContentText>
                      <img src={img} height="100" width="200" alt="med1" />
                    </DialogContentText>
                    <DialogContentText>
                      <img src={img1} height="100" width="200" alt="med1" />
                    </DialogContentText>
                    <DialogContentText>
                      <img src={img2} height="100" width="200" alt="med1" />
                    </DialogContentText>
                  </DialogContent>

                  <DialogActions>
                    <Button onClick={handleClose} color="primary">
                      إغلاق
                    </Button>
                    <Button
                      onClick={() => {
                        handelUpdateImage(id);
                      }}
                      color="primary"
                    >
                      تعديل الصور
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
            <table className="table">
              <tr>
                <th>الاسم</th>
                <td>{userfirstname}</td>
                <th>الكنية</th>
                <td>{userlastname}</td>
              </tr>
              <tr>
                <th>رقم الموبايل</th>
                <td>{usermobilenumber}</td>
                <th>الرقم الوطني</th>
                <td>{useridnumber}</td>
              </tr>
              <tr>
                <th>اسم الأم</th>
                <td>{userMotherName}</td>
                <th>اسم الأب</th>
                <td>{userFatherName}</td>
              </tr>
              <tr>
                <th>المحافظة</th>
                <td>{usercity}</td>
                <th>المنطقة</th>
                <td>{userzone}</td>
              </tr>
              <tr>
                <th>تاريخ الطلب</th>
                <td>{usercreated}</td>
              </tr>
            </table>
          </div>
          {type == "ادمن" ? null : (
            <div className="userfounds">
              <div className="userfoundsborder">
                <h3>الرصيد:{satffFund}</h3>
              </div>
              <table className="table">
                <tr>
                  <th>اسم الرصيد</th>
                  <td>{satffFund}</td>
                  <th>قيمة الرصيد</th>
                  <td>{fundvalue}</td>
                </tr>
              </table>
            </div>
          )}
        </Grid>
        <Grid item xs={8}></Grid>
      </Grid>

      <div className="permission"></div>
      <div></div>
    </div>
  );
}
